// @storybook-skip: container wiring the session insights stream into SessionTipSlotView
import { useAppStore } from "@hooks/useAppStore";
import type { ReportDetails } from "@memorang/types";
import { useSessionInsights } from "../hooks/useSessionInsights";
import { SessionTipSlotView } from "./SessionTipSlotView";

type Props = {
	reportDetails: ReportDetails;
	examId: string;
	appId: string;
	tenantName: string;
	outputLanguage: string;
	handleTracking: (
		eventName: string,
		params?: Record<string, string | number>,
	) => void;
};

export const SessionInsightsTipSlot = ({
	reportDetails,
	examId,
	appId,
	tenantName,
	outputLanguage,
	handleTracking,
}: Props) => {
	const sessionAnalysisEnabled = Boolean(
		useAppStore((s) => s.reportView?.ai?.sessionAnalysis),
	);

	const enabled =
		Boolean(examId) &&
		!reportDetails.isMigratedProgress &&
		sessionAnalysisEnabled;

	const { summary, insights, loading, insightsLoading, streaming, error } =
		useSessionInsights({
			sessionId: Number(reportDetails.id),
			examName: reportDetails.examName,
			examId,
			appId,
			tenantName,
			outputLanguage,
			enabled,
		});

	return (
		<SessionTipSlotView
			reportDetails={reportDetails}
			tenantName={tenantName}
			outputLanguage={outputLanguage}
			preview={{ text: summary, isLoading: loading, isError: error }}
			fullReport={{
				data: insights,
				isLoading: insightsLoading,
				streaming,
				canOpen: enabled,
			}}
			handleTracking={handleTracking}
		/>
	);
};
